/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessProfile,
    BusinessProfileFromJSON,
    BusinessProfileFromJSONTyped,
    BusinessProfileToJSON,
} from './BusinessProfile';
import {
    BusinessType,
    BusinessTypeFromJSON,
    BusinessTypeFromJSONTyped,
    BusinessTypeToJSON,
} from './BusinessType';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    ExternalAccounts,
    ExternalAccountsFromJSON,
    ExternalAccountsFromJSONTyped,
    ExternalAccountsToJSON,
} from './ExternalAccounts';
import {
    PayoutProvider,
    PayoutProviderFromJSON,
    PayoutProviderFromJSONTyped,
    PayoutProviderToJSON,
} from './PayoutProvider';
import {
    Payouts,
    PayoutsFromJSON,
    PayoutsFromJSONTyped,
    PayoutsToJSON,
} from './Payouts';
import {
    Requirements,
    RequirementsFromJSON,
    RequirementsFromJSONTyped,
    RequirementsToJSON,
} from './Requirements';
import {
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface PayoutSetting
 */
export interface PayoutSetting {
    /**
     * 
     * @type {string}
     * @memberof PayoutSetting
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutSetting
     */
    object: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutSetting
     */
    program_id: string;
    /**
     * 
     * @type {PayoutProvider}
     * @memberof PayoutSetting
     */
    provider: PayoutProvider;
    /**
     * 
     * @type {string}
     * @memberof PayoutSetting
     */
    provider_id: string;
    /**
     * 
     * @type {BusinessProfile}
     * @memberof PayoutSetting
     */
    business_profile: BusinessProfile;
    /**
     * 
     * @type {BusinessType}
     * @memberof PayoutSetting
     */
    business_type: BusinessType;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutSetting
     */
    card_payments_enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutSetting
     */
    charges_enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof PayoutSetting
     */
    country: string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof PayoutSetting
     */
    default_currency: CurrencyCode;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutSetting
     */
    details_submitted: boolean;
    /**
     * 
     * @type {ExternalAccounts}
     * @memberof PayoutSetting
     */
    external_accounts?: ExternalAccounts;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutSetting
     */
    payouts_enabled: boolean;
    /**
     * 
     * @type {Payouts}
     * @memberof PayoutSetting
     */
    payouts?: Payouts;
    /**
     * 
     * @type {Requirements}
     * @memberof PayoutSetting
     */
    requirements: Requirements;
    /**
     * 
     * @type {string}
     * @memberof PayoutSetting
     */
    terminal_location_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutSetting
     */
    transfers_enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutSetting
     */
    is_legacy_account: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutSetting
     */
    is_active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayoutSetting
     */
    has_terminal: boolean;
    /**
     * 
     * @type {string}
     * @memberof PayoutSetting
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof PayoutSetting
     */
    created: Date;
    /**
     * 
     * @type {User}
     * @memberof PayoutSetting
     */
    created_by: User;
    /**
     * 
     * @type {Date}
     * @memberof PayoutSetting
     */
    updated?: Date;
    /**
     * 
     * @type {User}
     * @memberof PayoutSetting
     */
    updated_by?: User;
}

export function PayoutSettingFromJSON(json: any): PayoutSetting {
    return PayoutSettingFromJSONTyped(json, false);
}

export function PayoutSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayoutSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': json['object'],
        'program_id': json['program_id'],
        'provider': PayoutProviderFromJSON(json['provider']),
        'provider_id': json['provider_id'],
        'business_profile': BusinessProfileFromJSON(json['business_profile']),
        'business_type': BusinessTypeFromJSON(json['business_type']),
        'card_payments_enabled': json['card_payments_enabled'],
        'charges_enabled': json['charges_enabled'],
        'country': json['country'],
        'default_currency': CurrencyCodeFromJSON(json['default_currency']),
        'details_submitted': json['details_submitted'],
        'external_accounts': !exists(json, 'external_accounts') ? undefined : ExternalAccountsFromJSON(json['external_accounts']),
        'payouts_enabled': json['payouts_enabled'],
        'payouts': !exists(json, 'payouts') ? undefined : PayoutsFromJSON(json['payouts']),
        'requirements': RequirementsFromJSON(json['requirements']),
        'terminal_location_id': !exists(json, 'terminal_location_id') ? undefined : json['terminal_location_id'],
        'transfers_enabled': json['transfers_enabled'],
        'is_legacy_account': json['is_legacy_account'],
        'is_active': json['is_active'],
        'has_terminal': json['has_terminal'],
        'timezone': json['timezone'],
        'created': (new Date(json['created'])),
        'created_by': UserFromJSON(json['created_by']),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'updated_by': !exists(json, 'updated_by') ? undefined : UserFromJSON(json['updated_by']),
    };
}

export function PayoutSettingToJSON(value?: PayoutSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': value.object,
        'program_id': value.program_id,
        'provider': PayoutProviderToJSON(value.provider),
        'provider_id': value.provider_id,
        'business_profile': BusinessProfileToJSON(value.business_profile),
        'business_type': BusinessTypeToJSON(value.business_type),
        'card_payments_enabled': value.card_payments_enabled,
        'charges_enabled': value.charges_enabled,
        'country': value.country,
        'default_currency': CurrencyCodeToJSON(value.default_currency),
        'details_submitted': value.details_submitted,
        'external_accounts': ExternalAccountsToJSON(value.external_accounts),
        'payouts_enabled': value.payouts_enabled,
        'payouts': PayoutsToJSON(value.payouts),
        'requirements': RequirementsToJSON(value.requirements),
        'terminal_location_id': value.terminal_location_id,
        'transfers_enabled': value.transfers_enabled,
        'is_legacy_account': value.is_legacy_account,
        'is_active': value.is_active,
        'has_terminal': value.has_terminal,
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
        'created_by': UserToJSON(value.created_by),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'updated_by': UserToJSON(value.updated_by),
    };
}

